// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__6kbcQ","log":"ModalInventoryLogs_log__3iESE","date":"ModalInventoryLogs_date__3OkPR","userName":"ModalInventoryLogs_userName__Uq6Zv"};